export const SITE_URL = process.env.ROOT_API
export const REST_URL = 'wp-json/rv/v1/'
export const API_URL = SITE_URL + REST_URL
export const PANARAY_SERVICES_URL = process.env.PANARAY_SERVICES



// WEBPACK FOOTER //
// ./src/api/config.js